import React from "react";
import { MdClose } from "react-icons/md";
import style from "./css/style.module.css";

const Modal = ({ open, setOpen, onClose, children }) => {
	window.scroll({
		top: 0,
		left: 0,
		behavior: "smooth",
	});

	const handleClose = () => {
		if (typeof onClose === "function") onClose();
		setOpen(true);
	};

	return (
		<div
			style={{ display: open ? "none" : "" }}
			className={style.container}
			onClick={handleClose}
		>
			<div className={style.form} onClick={(event) => event.stopPropagation()}>
				<MdClose
					fontSize={"2em"}
					onClick={handleClose}
					style={{
						cursor: "pointer",
						backgroundColor: "red",
						color: "white",
						borderRadius: "50%",
						transform: "translateY(-5px)",
					}}
					className={style.closeButton}
				/>
				{children}
			</div>
		</div>
	);
};

Modal.defaultProps = {
	className: "",
};
export default Modal;
